


















import Vue from 'vue'
import Lottie from 'vue-lottie'
import loadingAnimation from '@/assets/json/loading.json'

export default Vue.extend({
  name: 'Loading',
  components: {
    Lottie,
  },
  props: {
    height: {
      type: Number,
      default: 160,
    },
    width: {
      type: Number,
      default: 160,
    },
  },
  data: () => ({
    options: {
      animationData: loadingAnimation,
    },
  }),
})
